/**
 * Computes the sum of the values in array, but it accepts predicate which is invoked for each element in array to generate the value to be summed
 *
 * @param {Array<number>} arr
 * @param {Function | string} predicate
 * @return {number}
 *
 * @example
 * generateSumByTheGivenPredicate([1,2,3], x => x*2);
 * // returns 12
 */
export var generateSumByTheGivenPredicate = function (arr, predicate) {
    var predicateToApply = predicate && typeof predicate === 'function'
        ? predicate
        : function (object) { return object[predicate]; };
    return arr.reduce(function (acc, item) { return acc + predicateToApply(item); }, 0);
};
//# sourceMappingURL=generateSumByTheGivenPredicate.js.map